// extracted by mini-css-extract-plugin
module.exports = {"root":"BlogCTA-module--root--2mWHg","name":"BlogCTA-module--name--hD8ZR"};